import AxiosInstance from "./api";

export const FixedAssetsInventorySummaryService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/fixed-asset-inventory-record", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/fixed-asset-inventory-record/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/fixed-asset-inventory-record", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/fixed-asset-inventory-record/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/fixed-asset-inventory-record/" + id);
  },
};
